<template>
  <div class="row ">
    <div class="col-md-12 login-holder">
      <div class="login-box ">
        <img src="../assets/logo.png" alt="Logo" class="img-fluid logo" />
        <form @submit.prevent="login">
          <div class="form-group">
            <input type="email" class="form-control" placeholder="Email" required ref="email" />
          </div>
          <div class="form-group">
            <input :type="showPass ? 'text' : 'password'" class="form-control"  placeholder="Password" ref="password" required minlength="3" />
            <div class="login-icon icon-password">
              <svg @click="showPass = true" v-if="!showPass" xmlns="http://www.w3.org/2000/svg" width="23" height="16" viewBox="0 0 23 16"><g class="a" transform="translate(0 -74.667)"><g transform="translate(0 74.667)"><path d="M173.889,170.667a3.222,3.222,0,1,0,3.222,3.222A3.224,3.224,0,0,0,173.889,170.667Z" transform="translate(-162.389 -165.889)"/><path d="M11.5,74.667a12.372,12.372,0,0,0-11.5,8,12.372,12.372,0,0,0,11.5,8,12.367,12.367,0,0,0,11.5-8A12.367,12.367,0,0,0,11.5,74.667ZM11.5,88a5.334,5.334,0,1,1,5.227-5.333A5.283,5.283,0,0,1,11.5,88Z" transform="translate(0 -74.667)"/></g></g></svg>
              <svg @click="showPass = false" v-else version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 512.008 512.008" style="enable-background:new 0 0 512.008 512.008;" xml:space="preserve"   height="24">
                <g>
                  <g>
                    <path d="M256.011,106.673c-131.435,0-248.555,136.619-253.483,142.443c-3.371,3.968-3.371,9.792,0,13.781
                      c2.944,3.477,45.995,53.461,108.075,93.269l66.859-66.859c-4.352-10.24-6.784-21.483-6.784-33.301
                      c0-47.061,38.272-85.333,85.333-85.333c11.819,0,23.061,2.432,33.301,6.784l54.976-54.976
                      C317.493,112.902,288.075,106.673,256.011,106.673z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M510.112,249.926c-2.731-3.947-48.021-67.691-124.16-108.779l58.944-58.944c4.16-4.16,4.16-10.923,0-15.083
                      c-4.16-4.16-10.923-4.16-15.083,0L67.147,429.788c-4.16,4.16-4.16,10.923,0,15.083c2.069,2.091,4.8,3.136,7.531,3.136
                      c2.731,0,5.461-1.045,7.552-3.115l66.88-66.88c32.96,16.085,69.312,27.328,106.901,27.328
                      c131.435,0,248.555-136.619,253.483-142.443C512.587,259.206,512.864,253.894,510.112,249.926z M256.011,341.34
                      c-19.691,0-37.589-6.976-52.053-18.197l119.189-119.189c11.221,14.464,18.197,32.363,18.197,52.053
                      C341.344,303.068,303.072,341.34,256.011,341.34z"/>
                  </g>
                </g>
                </svg>
            </div>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-login btn-block">LogIn</button>
          </div>
          <div class="form-group">
            <router-link :to="{name: 'ForgotPassword'}" class="btn  mt-3 text-link mx-auto d-block f14">
              Forgot Password
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      showPass: false
    }
  },
  methods: {
    login(){
      let email = this.$refs.email.value
      let password = this.$refs.password.value
      if(email.length > 0 && password.length > 0){
        this.$axios.post('login', {email, password})
          .then(res => {
            localStorage.setItem('radiate-user-name', res.data.data.name);
            localStorage.setItem('radiate-user-id', res.data.data.user_id);
            localStorage.setItem('radiate-user-email', res.data.data.email);
            localStorage.setItem('radiate-crm-token', res.data.data.token);
            localStorage.setItem('radiate-crm-role_id', res.data.data.role_id);
            localStorage.setItem('radiate-crm-role_name', res.data.data.role_name);
            localStorage.setItem('radiate-user-sourcing',res.data.data.is_sourcing);
            this.sendOTP()
          })
          .catch(err => {
            swal({
              title: "Login Failed",
              text: err.response.data.message,
              icon: "error"
            })
          })
      }else{
        swal({
          title: "Please enter Email and Password",
          icon: "info"
        })
      }
    },
    sendOTP() {
      this.$axios.post(`send_otp?email=${this.$refs.email.value}`).then((res) => {
        swal({
          title: "OTP sent to Register Email",
          icon: "success"
        })
        this.$router.replace({name: "OTP", query: {email: this.$refs.email.value}});
      }).catch(err => {
        if (err.response.status === 500) {
          swal({
            title: "Server Error!",
            icon: "error"
          });
        } else {
          swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error"
          });
        }
      })
    },
  }
}
</script>
<style scoped>
  svg{
    opacity: 0.2;
  }
  .f14{
  font-size:14px ;
}
</style>